import Component from "./loadable";


export default Component;
